import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
const Footer: React.FC = () => {
  return <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-gray-300" data-id="element-309">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-310">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-311">
          {/* About Section */}
          <div className="col-span-1 md:col-span-2" data-id="element-312">
            <div className="flex items-center mb-4" data-id="element-313">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iLjN9cDQjVbDSGqwWquEQb/1000138367.png" alt="Edo State Logo" className="h-12 w-auto mr-3" data-id="element-314" />
              <div data-id="element-315">
                <h3 className="text-white font-bold text-lg" data-id="element-316">
                  Edo State Services Portal
                </h3>
                <p className="text-sm text-gray-400" data-id="element-317">
                  Digital Government Services
                </p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4" data-id="element-318">
              Your one-stop platform for accessing all Edo State government
              services. Fast, transparent, and citizen-focused digital
              solutions.
            </p>
            <div className="space-y-2 text-sm" data-id="element-319">
              <div className="flex items-center text-gray-400" data-id="element-320">
                <MapPinIcon className="h-4 w-4 mr-2 text-green-500" data-id="element-321" />
                <span data-id="element-322">Edo State Government House, Benin City</span>
              </div>
              <div className="flex items-center text-gray-400" data-id="element-323">
                <PhoneIcon className="h-4 w-4 mr-2 text-green-500" data-id="element-324" />
                <span data-id="element-325">+234 (0) 800 EDO HELP</span>
              </div>
              <div className="flex items-center text-gray-400" data-id="element-326">
                <MailIcon className="h-4 w-4 mr-2 text-green-500" data-id="element-327" />
                <span data-id="element-328">support@edostate.gov.ng</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-329">
            <h4 className="text-white font-semibold mb-4" data-id="element-330">Quick Links</h4>
            <ul className="space-y-2 text-sm" data-id="element-331">
              <li data-id="element-332">
                <Link to="/mdas" className="text-gray-400 hover:text-green-400 transition-colors duration-200" data-id="element-333">
                  Browse Services
                </Link>
              </li>
              <li data-id="element-334">
                <Link to="/track-application" className="text-gray-400 hover:text-green-400 transition-colors duration-200" data-id="element-335">
                  Track Application
                </Link>
              </li>
              <li data-id="element-336">
                <Link to="/support" className="text-gray-400 hover:text-green-400 transition-colors duration-200" data-id="element-337">
                  Support Center
                </Link>
              </li>
              <li data-id="element-338">
                <Link to="/help" className="text-gray-400 hover:text-green-400 transition-colors duration-200" data-id="element-339">
                  Help & FAQs
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-340">
            <h4 className="text-white font-semibold mb-4" data-id="element-341">Legal</h4>
            <ul className="space-y-2 text-sm" data-id="element-342">
              <li data-id="element-343">
                <Link to="/terms" className="text-gray-400 hover:text-green-400 transition-colors duration-200" data-id="element-344">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-345">
                <Link to="/privacy" className="text-gray-400 hover:text-green-400 transition-colors duration-200" data-id="element-346">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-347">
                <a href="#" className="text-gray-400 hover:text-green-400 transition-colors duration-200" data-id="element-348">
                  Accessibility
                </a>
              </li>
              <li data-id="element-349">
                <a href="#" className="text-gray-400 hover:text-green-400 transition-colors duration-200" data-id="element-350">
                  Data Protection
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700" data-id="element-351">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-352">
            <p className="text-sm text-gray-400 mb-4 md:mb-0" data-id="element-353">
              © {new Date().getFullYear()} Edo State Government. All rights
              reserved.
            </p>
            <p className="text-sm text-gray-400" data-id="element-354">
              Powered by{' '}
              <span className="text-green-400 font-medium" data-id="element-355">Edo ICT Agency</span>
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;